import { render } from "./AddTraineeModal.vue?vue&type=template&id=58739627&scoped=true"
import script from "./AddTraineeModal.vue?vue&type=script&lang=js"
export * from "./AddTraineeModal.vue?vue&type=script&lang=js"

import "./AddTraineeModal.vue?vue&type=style&index=0&id=58739627&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58739627"]])

export default __exports__